import { useRoutes } from 'react-router-dom';

// project import
import LoginRoutes from './login-routes/LoginRoutes';
import MainRoutes from './main-routes/MainRoutes';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    return useRoutes([LoginRoutes, MainRoutes]);
}
